exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mar-top[data-v-10177ab2] {\n    margin-top: 0.75rem;\n}\n", "", {"version":3,"sources":["/app/src/pages/billing/Details.vue"],"names":[],"mappings":";AACA;IACI,oBAAoB;CACvB","file":"Details.vue","sourcesContent":["\n.mar-top[data-v-10177ab2] {\n    margin-top: 0.75rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10177ab2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/billing/Details.vue
// module id = 4qjO
// module chunks = 4